import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Fireworks } from 'fireworks-js/dist/react';
import './WinScreen.css';
import spiderLogo from '../../assets/images/logo2.png';
import trophyIcon from '../../assets/images/trophy.png';
import fireworkAudio from '../../assets/sound/applause.mp3';

const WinScreen = (props) => {
    const time = props.location.state?.time || 0;
    const click = props.location.state?.click || 0;
    const [showStats, setShowStats] = useState(false);

    let audio = useRef();

    // Start the audio when the component mounts
    useEffect(() => {
        audio.current = new Audio(fireworkAudio);
        audio.current.play();
        
        // Delayed stats animation
        const timer = setTimeout(() => {
            setShowStats(true);
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    // Stop the audio when the component unmounts
    useEffect(() => {
        return () => {
            if (audio.current) {
                audio.current.pause();
            }
        };
    }, []);

    const calculateScore = () => {
        const baseScore = 2000 + 500; // 8 completed decks * 250 + win bonus
        const penalty = time * click;
        const score = (baseScore / penalty) * 100000;
        return Math.ceil(score);
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const getPerformanceRating = () => {
        const score = calculateScore();
        if (score > 500000) return { rating: 'Excellent!', color: '#4ade80' };
        if (score > 300000) return { rating: 'Great!', color: '#22d3ee' };
        if (score > 150000) return { rating: 'Good!', color: '#a855f7' };
        return { rating: 'Complete!', color: '#f59e0b' };
    };

    const fireworksOptions = {
        speed: 15,
        acceleration: 1.05,
        friction: 0.95,
        gravity: 1.5,
        particles: 50,
        trace: 3,
        explosion: 5
    };

    const fireworksStyle = {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: 1
    };

    const performance = getPerformanceRating();

    return (
        <div className="win-container">
            <Fireworks options={fireworksOptions} style={fireworksStyle} />
            
            <div className="win-content">
                <div className="logo-container">
                    <div className="trophy-container">
                        <img src={trophyIcon} alt="Trophy" className="trophy-icon" />
                    </div>
                    <h1 className="game-title victory-title">Victory!</h1>
                    <div className="spider-logo">
                        <img src={spiderLogo} alt="Spider Logo" />
                    </div>
                </div>

                <div className={`win-stats ${showStats ? 'show' : ''}`}>
                    <div className="win-section score-highlight">
                        <div className="score-label">Final Score</div>
                        <div className="score-value">{calculateScore().toLocaleString()}</div>
                        <div className="performance-rating" style={{ color: performance.color }}>
                            {performance.rating}
                        </div>
                    </div>

                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-icon">⏱️</div>
                            <div className="stat-label">Time</div>
                            <div className="stat-value">{formatTime(time)}</div>
                        </div>
                        
                        {/* <div className="stat-card">
                            <div className="stat-icon">👆</div>
                            <div className="stat-label">Moves</div>
                            <div className="stat-value">{click}</div>
                        </div> */}
                        
                        <div className="stat-card">
                            <div className="stat-icon">🃏</div>
                            <div className="stat-label">Decks</div>
                            <div className="stat-value">8/8</div>
                        </div>
                    </div>

                    <div className="win-section score-formula">
                        <p>Score = (2500 base points) ÷ (time × moves) × 100,000</p>
                    </div>
                </div>

                <div className="menu-buttons">
                    <Link to="/game">
                        <button className="menu-btn primary-btn">
                            Play Again
                        </button>
                    </Link>
                    
                    <Link to="/highscores">
                        <button className="menu-btn secondary-btn">
                            High Scores
                        </button>
                    </Link>
                    
                    <Link to="/">
                        <button className="menu-btn back-btn">
                            Main Menu
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default WinScreen; 